
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hP4wC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c22a390d74cb8774$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $c22a390d74cb8774$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u6240\u6709\u7DB2\u7AD9",
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u95DC\u9589",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u76EE\u524D\u7121\u6CD5\u4F7F\u7528)",
    'navigation.global-shortcuts.sites': "{productName} \u7DB2\u7AD9"
};

});


//# sourceMappingURL=zh_TW.85e0b2bc.js.map
